/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import { SET_INNER_PAGE } from "../actions/pages";

const state = {
  innerPage: ""
};

const getters = {
  innerPage: state => state.innerPage
};

const actions = {
  [SET_INNER_PAGE]: ({ commit }, page) => {
    commit(SET_INNER_PAGE, page);
  }
};

const mutations = {
  [SET_INNER_PAGE]: (state, page) => {
    state.innerPage = page;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
